import React, { useState } from 'react'
import { Typography, Box, Alert } from '@mui/material'
import { SidebarLayout } from '@/components/Layout'
import { ProtectedRoute } from '@/components/common'
import { ListingFormTabs } from '@/components/Listings'
import { ListingForm as ListingFormType } from '@/types'
import { ListingsService } from '@/utils/listings-service'
import { useNavigate } from 'react-router-dom'

export default function NewListing() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()

  const handleSave = async (listingData: ListingFormType) => {
    try {
      setIsLoading(true)
      setError(null)
      
      const newListing = await ListingsService.createListing(listingData)
      
      // Redirect to edit page for the new listing
      navigate(`/listings/${newListing.listingId}`)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create listing')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <SidebarLayout>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom>
            Create New Listing
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Add a new property to your portfolio
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        <ListingFormTabs
          onSave={handleSave}
          isLoading={isLoading}
        />
    </SidebarLayout>
  )
}